import { Injectable } from '@angular/core';

import { cloneDeep, findIndex, uniqBy } from 'lodash';
import { Enums } from '../../../../configs/Enums';

// working_shift
// {
//     "ws_id": null, # null - создать график с 0, id - измениить график
//     "workday": 2019-04-02, # дата ячейки
//     "user_number": ..., # user_number
//     "schedule": {
//          "int_begin": 2019-04-01T08:00:00,
//          "int_end": 2019-04-01T20:00:00,
//          "int_delta": 8, 7-30 // при сохранении не нужно, нужно лишь для превью, либо для рендера ячеек
//          "cell_type": 1, # FK esas.cell_types
//          "sector_number": ..., # sector_number, если командировка сотрудника
//          "transport_id": null, # пока просто null, т.к. с бека пока нет данных о транспорте
//          "commentary": "коментарий"
//      }
// }

@Injectable({
  providedIn: 'root',
})
export class WorkShiftsTemplateFilterService {
  moment = require('moment');
  public dateShortFormat = Enums.dates.shortFormat;
  public dateFullFormat = Enums.dates.fullFormat;

  constructor() {}

  makeCell(cell, user, selectedEntities, isWeekend) {
    const c = {
      ws_id: cell.ws_id || null,
      workday: cell.workday,
      user: user.u_id || '',
      schedule: {
        int_begin: null,
        int_end: null,
        cell_type: typeof isWeekend === 'boolean' && isWeekend ? selectedEntities.weekend.ct_id : selectedEntities.workTypeSelected.ct_id,
        sector: selectedEntities.workPlaceSelected && selectedEntities.workPlaceSelected.sector_id,
        commentary: selectedEntities.comment || '',
      },
    };

    if (c.schedule.cell_type === 1) {
      let intBegin = new Date(cell.workday);
      let endBegin = new Date(cell.workday);

      intBegin.setHours(selectedEntities.startWorkTime.hour);
      intBegin.setMinutes(selectedEntities.startWorkTime.minute);
      endBegin.setHours(selectedEntities.endWorkTime.hour);
      endBegin.setMinutes(selectedEntities.endWorkTime.minute);

      if (selectedEntities.endWorkTime.hour <= selectedEntities.startWorkTime.hour && selectedEntities.endWorkTime.minute <= selectedEntities.startWorkTime.minute) {
        endBegin = this.moment(cell.workday, 'YYYY-MM-DD').add(1, 'day').toDate();
        endBegin.setHours(selectedEntities.endWorkTime.hour);
        endBegin.setMinutes(selectedEntities.endWorkTime.minute);
      }

      c.schedule.int_begin = this.moment(intBegin).format(this.dateFullFormat);
      c.schedule.int_end = this.moment(endBegin).format(this.dateFullFormat);
    }

    return c;
  }

  makePeriodCell(selectedEntities) {
    const cells = [];
    const templateFilter = selectedEntities.templateFilter;
    const templateFilterData = selectedEntities.templateFilterData;
    const cellTypeSelected = selectedEntities.templateFilter.cellTypeSelected;
    const workTypeSelected = selectedEntities.templateFilter.workTypeSelected;
    const startPeriodDate = this.moment(templateFilter.startTemplatePeriod.dateMillis).format(this.dateShortFormat);
    const endPeriodDate = this.moment(templateFilter.endTemplatePeriod.dateMillis).format(this.dateShortFormat);
    const endMonthDate = this.moment(selectedEntities.filter.monthDate.initDate).endOf('month').format(this.dateShortFormat);

    let cellObjData = {
      weekend: templateFilterData.cellTypesList[findIndex(templateFilterData.cellTypesList, { ct_id: 8 })],
      workTypeSelected: workTypeSelected,
      cellTypeSelected: cellTypeSelected,
      comment: templateFilter.comment,
      startWorkTime: templateFilter.startWorkTime,
      endWorkTime: templateFilter.endWorkTime,
      workPlaceSelected: workTypeSelected.ct_id === 2 ? templateFilter.workPlaceSelected : null,
    };

    selectedEntities.templateFilter.selectedUsers.forEach((user) => {
      let countWork = 0;
      let countWikend = 0;
      let currentWork = 0;
      let currentWikend = 0;

      if (workTypeSelected.ct_id === 1) {
        switch (cellTypeSelected.st_id) {
          case 1:
            countWork = 5;
            countWikend = 2;
            break;
          case 2:
            countWork = 2;
            countWikend = 2;
            break;
          default:
            break;
        }
      }

      // Удаляем дубликаты по полю workday перед обработкой
      // Приоритет: записи с ws_id (существующие) над записями без ws_id (новые)
      const sortedShifts = user.working_shift.sort((a, b) => {
        if (a.workday !== b.workday) return 0;
        // Если даты одинаковые, приоритет записям с ws_id
        return (b.ws_id ? 1 : 0) - (a.ws_id ? 1 : 0);
      });
      const uniqueWorkingShifts = uniqBy<{ workday: string; ws_id?: number }>(sortedShifts, 'workday');

      uniqueWorkingShifts.forEach((work_shift) => {
        if (work_shift.workday >= startPeriodDate && work_shift.workday <= endPeriodDate) {
          if (currentWork === countWork && currentWikend === countWikend) {
            currentWork = 0;
            currentWikend = 0;
          }

          if (selectedEntities.templateFilter.workTypeSelected.ct_id === 1) {
            switch (selectedEntities.templateFilter.cellTypeSelected.st_id) {
              case 1:
              case 2:
                if (currentWork < countWork) {
                  cells.push(this.makeCell(work_shift, user, cellObjData, false));

                  currentWork++;
                } else {
                  cells.push(this.makeCell(work_shift, user, cellObjData, true));

                  currentWikend++;
                }
                break;
              case 3:
                cells.push(this.makeCell(work_shift, user, cellObjData, false));

                break;
              case 4:
                cells.push(this.makeCell(work_shift, user, cellObjData, true));

                break;
              default:
                break;
            }
          } else {
            cells.push(this.makeCell(work_shift, user, cellObjData, false));
          }
        }
      });
    });

    // Финальная защита: убираем возможные дубликаты в итоговом массиве
    // Дедупликация по комбинации user + workday
    const uniqueCells = [];
    const processedKeys = new Set();

    cells.forEach((cell) => {
      const key = `${cell.user}_${cell.workday}`;
      if (!processedKeys.has(key)) {
        processedKeys.add(key);
        uniqueCells.push(cell);
      }
    });

    return uniqueCells;
  }

  makePreviewCell(cell, previewData, isWeekend) {
    const workType = isWeekend ? previewData.weekend : previewData.workTypeSelected;
    const schedule_preview = {
      int_begin: null,
      int_end: null,
      int_delta: null,
      cell_type: workType,
      sector: null,
      commentary: previewData.comment || '',
    };

    switch (workType.ct_id) {
      case 1:
        let intBegin = new Date(cell.workday);
        let endBegin = new Date(cell.workday);
        let intDelta = null;
        let endDate = null;

        intBegin.setHours(previewData.startWorkTime.hour);
        intBegin.setMinutes(previewData.startWorkTime.minute);
        endBegin.setHours(previewData.endWorkTime.hour);
        endBegin.setMinutes(previewData.endWorkTime.minute);

        schedule_preview.int_begin = this.moment(intBegin).format(this.dateFullFormat);
        schedule_preview.int_end = this.moment(endBegin).format(this.dateFullFormat);

        if (previewData.endWorkTime.hour <= previewData.startWorkTime.hour && previewData.endWorkTime.minute <= previewData.startWorkTime.minute) {
          endDate = this.moment(schedule_preview.int_end).add(1, 'day').format(this.dateFullFormat);
        } else {
          endDate = schedule_preview.int_end;
        }

        intDelta = this.moment.duration(this.moment(endDate).diff(this.moment(schedule_preview.int_begin)));

        const totalHours = intDelta.asHours();
        const hours = Math.floor(totalHours);
        const minutes = intDelta.minutes();

        // Вычитаем время на обед: если рабочий день больше 6 часов, вычитаем 1 час
        const workHours = totalHours > 6 ? hours - 1 : hours;

        // Форматируем как строку для отображения
        const deltaString = minutes > 0 ? workHours + '-' + (minutes <= 9 ? '0' + minutes : minutes) : workHours.toString();

        // Сохраняем в миллисекундах для внутренних расчетов
        schedule_preview.int_delta = deltaString;

        break;
      case 2:
        schedule_preview.sector = previewData.workPlaceSelected;
        break;
      default:
        break;
    }

    return schedule_preview;
  }
}
